import React, { useEffect, useState } from 'react';
import AdminOrderScannerPickModalDesktop from './AdminOrderScannerPickModalDesktop';
import AdminOrderScannerPickModalMobile from './AdminOrderScannerPickModalMobile';
import { useAdminOrderScannerPick } from './useAdminOrderScannerPick';

/** Bootstrap `lg`: нижче — мобільний layout (картки), від `lg` — таблиця. */
function useScannerPickMobileLayout() {
  const query = '(max-width: 991.98px)';
  const [mobile, setMobile] = useState(() =>
    typeof window !== 'undefined' ? window.matchMedia(query).matches : false
  );

  useEffect(() => {
    const mq = window.matchMedia(query);
    const handler = () => setMobile(mq.matches);
    if (mq.addEventListener) mq.addEventListener('change', handler);
    else mq.addListener(handler);
    return () => {
      if (mq.removeEventListener) mq.removeEventListener('change', handler);
      else mq.removeListener(handler);
    };
  }, []);

  return mobile;
}

/**
 * Збірка замовлення по сканеру (стан pick-scans на сервері).
 * На мобільному — окремий компонент з картками; на десктопі — таблиця.
 */
const AdminOrderScannerPickModal = ({ show, onHide, order }) => {
  const pick = useAdminOrderScannerPick(show, order);
  const isMobileLayout = useScannerPickMobileLayout();

  if (!show || !order) return null;

  const close = () => pick.handleHide(onHide);

  return isMobileLayout ? (
    <AdminOrderScannerPickModalMobile pick={pick} order={order} onHide={close} />
  ) : (
    <AdminOrderScannerPickModalDesktop pick={pick} order={order} onHide={close} />
  );
};

export default AdminOrderScannerPickModal;
